import { useQuery } from '@apollo/client';
import {
  RESOURCE_ALLOCATIONS_QUERY,
  RESOURCE_ALLOCATIONS_QUERY_V2
} from '~/modules/resourcing/common/fragments';
import { useMeContext } from '~/modules/me';

const useProjectResourceAllocationsByIds = ({
  allocationIds,
  skip = false
}) => {
  const {
    isRoleCostMode,
    featureFlags: {
      isPsaRmpTaskAllocation1Enabled,
      isPsaRmpEnhancedProjectManagerPersonaEnabled
    }
  } = useMeContext();

  const { loading, data } = useQuery(
    isPsaRmpTaskAllocation1Enabled &&
      isPsaRmpEnhancedProjectManagerPersonaEnabled
      ? RESOURCE_ALLOCATIONS_QUERY_V2
      : RESOURCE_ALLOCATIONS_QUERY,
    {
      variables: {
        filter: {
          resourceAllocationIds: allocationIds
        },
        includeRoleCurrentRate: isRoleCostMode,
        includeUserPermittedActions: false,
        includeUserRoles: false
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      skip
    }
  );

  return {
    loadingAllocations: loading,
    resourceAllocations: data?.resourceAllocations?.resourceAllocations || []
  };
};

export default useProjectResourceAllocationsByIds;
